import { ArrowRight, CheckCircle2, Search, ShieldCheck, Sparkles, Truck, Wrench } from "lucide-react";
import { Link } from "react-router-dom";
import { ProductCard } from "../../components/commerce/ProductCard";
import { categoryGroups } from "../../data/navigation";
import { products } from "../../data/products";

export function HomePage() {
  return (
    <main>
      <section className="hero">
        <div className="container">
          <div className="hero-shell">
            <div className="hero-copy">
              <span className="hero-kicker">Phụ tùng chính hãng</span>
              <h1>
                Hỏi là có, <span>đúng mã</span> là giao
              </h1>
              <p>
                Tìm phụ tùng xe điện, xe máy, ô tô điện và theo dõi đơn hàng,
                kho, marketplace trong một hệ thống gọn rõ.
              </p>
              <div className="hero-benefits">
                <span className="hero-benefit">
                  <CheckCircle2 aria-hidden="true" /> Kiểm tra tương thích
                </span>
                <span className="hero-benefit">
                  <Truck aria-hidden="true" /> Theo dõi đơn rõ ràng
                </span>
                <span className="hero-benefit">
                  <Wrench aria-hidden="true" /> Sourcing phụ tùng khó
                </span>
              </div>
              <div className="hero-actions">
                <Link className="btn btn-primary" to="/search">
                  <Search aria-hidden="true" />
                  <span>Tìm phụ tùng</span>
                </Link>
                <Link className="btn btn-secondary" to="/ask">
                  <Sparkles aria-hidden="true" />
                  <span>Gửi Hỏi là có</span>
                </Link>
              </div>
            </div>
            <div className="hero-art">
              <div className="hero-art-inner">
                <div className="hero-product-orbit">
                  <span className="part part-a">48V</span>
                  <span className="part part-b">SKU</span>
                  <span className="part part-c">OEM</span>
                </div>
                <div className="hero-device">
                  <div className="device-head">
                    <span>Siêu Thị Ưa Thích</span>
                    <strong>Đồng bộ vận hành</strong>
                  </div>
                  <div className="device-rows">
                    <i />
                    <i />
                    <i />
                    <i />
                  </div>
                  <div className="device-chart">
                    <b style={{ height: "42%" }} />
                    <b style={{ height: "70%" }} />
                    <b style={{ height: "58%" }} />
                    <b style={{ height: "88%" }} />
                    <b style={{ height: "76%" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container section-head">
          <div>
            <h2>Danh mục trọng điểm</h2>
            <p>Giữ đúng nhịp commerce của V3.1: tìm nhanh theo xe, điện áp, SKU và nhóm hàng.</p>
          </div>
          <Link className="text-link" to="/category/phu-tung-xe-dien">
            Xem tất cả <ArrowRight aria-hidden="true" />
          </Link>
        </div>
        <div className="container category-grid">
          {categoryGroups.map((group) => (
            <Link key={group.title} className="category-card" to="/category/phu-tung-xe-dien">
              <span>{group.title.slice(0, 2).toUpperCase()}</span>
              <strong>{group.title}</strong>
              <p>{group.description}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className="finder-band">
        <div className="container finder">
          <div>
            <h2>Tìm đúng phụ tùng theo xe</h2>
            <p>Nhập dòng xe, điện áp, công suất hoặc ảnh phụ tùng để đội kỹ thuật kiểm tra.</p>
          </div>
          <form className="finder-form" onSubmit={(event) => event.preventDefault()}>
            <input placeholder="Ví dụ: Klara 60V sạc tự ngắt" />
            <select defaultValue="xe-dien">
              <option value="xe-dien">Xe điện</option>
              <option value="xe-may">Xe máy</option>
              <option value="oto-dien">Ô tô điện</option>
            </select>
            <button type="submit">Kiểm tra</button>
          </form>
        </div>
      </section>

      <section className="section">
        <div className="container section-head">
          <div>
            <h2>Sản phẩm đang chạy</h2>
            <p>Mock data chuẩn để chờ nối database thật, không giả API production.</p>
          </div>
          <Link className="text-link" to="/search">
            Tìm thêm <ArrowRight aria-hidden="true" />
          </Link>
        </div>
        <div className="container product-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>

      <section className="section split-section">
        <div className="container split-grid">
          <div className="ask-panel">
            <ShieldCheck aria-hidden="true" />
            <h2>Hỏi là có</h2>
            <p>Form sourcing giữ lịch sử yêu cầu, trạng thái và phản hồi kỹ thuật cho từng khách.</p>
            <Link className="btn btn-primary" to="/ask">
              <span>Gửi yêu cầu</span>
            </Link>
          </div>
          <div className="b2b-panel">
            <h2>B2B / Đại lý</h2>
            <p>Cấp giá, công nợ, hạn mức và đơn nhanh cho garage, đội xe, thợ sửa.</p>
            <div className="mini-metrics">
              <span>
                <strong>3 cấp</strong>
                Giá B2B
              </span>
              <span>
                <strong>24h</strong>
                Phản hồi
              </span>
              <span>
                <strong>Admin</strong>
                Theo dõi
              </span>
            </div>
            <Link className="btn btn-dark" to="/b2b">
              <span>Mở B2B</span>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
